/* import __COLOCATED_TEMPLATE__ from './free-seats-automation-rate-tooltip.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {};
}

const FreeSeatsAutomationRateTooltip = templateOnlyComponent<Signature>();
export default FreeSeatsAutomationRateTooltip;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'CompellingOffer::FreeSeatsAutomationRateTooltip': typeof FreeSeatsAutomationRateTooltip;
    'compelling-offer/free-seats-automation-rate-tooltip': typeof FreeSeatsAutomationRateTooltip;
  }
}
